<div class="personal-title-slot" aria-hidden="true">
  @if (showPersonalTitle) {
    <span class="personal-title-text text-c2-m-500 text-sm-c2-l-500 text-md-b3-s-500 text-lg-b3-m-500">ваша цена</span>
  }
</div>
<div class="prices-row">
  @if (mainPrice) {
    <div
      class="price-retail"
      [class.active]="!transitState"
      [class.not-available]="isNotAvailable"
      [class.has-discount]="hasDiscount"
      (click)="onSwitchPrice(false)"
    >
      <span class="price-retail-value">{{ mainPrice.formattedValue }}</span>
    </div>
  }
  @if (transitPrice) {
    <div class="price-transit" (click)="onSwitchPrice(true)" [class.active]="transitState">
      <span class="price-transit-content">
        <span
          class="price-transit-value text-b4-s-900 text-sm-b4-m-900 text-md-b2-m-900 text-lg-b2-l-900 text-xl-b1-l-900"
        >
          {{ transitPrice.formattedValue }}
        </span>
        <span class="price-transit-label text-c2-s-300">с завода</span>
      </span>
    </div>
  }
</div>
